var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loaded,
          expression: "loaded"
        },
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          modifiers: { hover: true }
        }
      ],
      staticClass: "timer-container",
      attrs: {
        title: _vm.videoTooltip
          ? _vm.$t("videosession-end-caption", { date: _vm.endHour })
          : _vm.$t("timer-end", { date: _vm.endHour })
      }
    },
    [
      _c(
        "span",
        { class: { "danger-limit": _vm.limitDate && _vm.limitExceeded } },
        [_vm._v(_vm._s(_vm.time))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e0c2232", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0c2232","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Timer.vue
// module id = 3614
// module chunks = 29